import * as React from "react";
import { SVGProps, memo } from "react";

const SvgAnnounce = (props: SVGProps<SVGSVGElement>) => (
  <svg width={80} height={80} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx={40} cy={40} r={40} fill="#D5E8DE" />

    <path
      d="m52.022 41.843-3.743-6.555-1.342-2.356-.731-1.254v-.015l-3.728-6.555c-.433-.74-1.208-1.208-2.058-1.208-.418 0-.835.106-1.193.332a2.423 2.423 0 0 0-.88 3.293l8.605 15.073.939 1.661a2.373 2.373 0 0 0 3.266.892c1.148-.665 1.52-2.145.865-3.308Z"
      fill="#FF9811"
    />

    <path
      d="M50.352 31.663a2.373 2.373 0 0 0-3.266-.891c-.045.03-.105.06-.15.09a2.61 2.61 0 0 0-.73.786v.015l.73 1.254 1.343 2.356c.417.015.835-.106 1.193-.317 1.133-.65 1.536-2.13.88-3.293Z"
      fill="#FF5023"
    />

    <path
      d="m40.972 53.895-3.624-6.373-.91-1.586-1.282.181-2.386 1.405-1.73 1.012-1.044.604 3.206 5.633 1.566 2.75a2.385 2.385 0 0 0 3.266.875l2.058-1.208a2.43 2.43 0 0 0 1.163-2.417 2.24 2.24 0 0 0-.283-.876Z"
      fill="#7F8695"
    />

    <path
      d="m30.384 37.75-4.13 2.416 4.205 7.356.566 1.011 1.745-1.011 2.401-1.405-4.787-8.367Z"
      fill="#FF5023"
    />

    <path
      d="m30.459 47.522-4.206-7.356-2.058 1.209a2.419 2.419 0 0 0-.88 3.277l.015.015 1.626 2.855.76 1.344a2.367 2.367 0 0 0 3.251.876l1.03-.604 1.043-.604-.581-1.012ZM52.842 28.794l4.13-2.417 1.194 2.1-4.131 2.416-1.193-2.1ZM48.89 25.954 50.204 21l2.311.62-1.312 4.953-2.311-.62ZM54.497 35.816l.611-2.34L60 34.804l-.612 2.34-4.89-1.329Z"
      fill="#FF9811"
    />

    <path
      d="m46.937 42.598-8.604-15.073-7.949 10.225 4.772 8.367 1.283-.181 10.498-1.54.94-.137-.94-1.661Z"
      fill="#FFDF34"
    />
  </svg>
);

const Memo = memo(SvgAnnounce);

export default Memo;
